import type { MobileConfig } from '@shared-core/features/config/models'
import { selectedAppConfig } from '@shared-core/features/config/selectors'
import { useAppSelector } from '@shared-core/store/hooks'

export function useMobileConfig(): MobileConfig {
  return useAppSelector(selectedAppConfig)
}
